import { graphql } from 'gatsby'
import { getImageBySize } from '../Images/Image'

export const fragment = graphql`
  fragment authorFields on WpUser {
    name
    description
    acfUser {
      role
      profileImage {
        ...mediaItemFields
      }
    }
  }
`

export const transformData = data => {
  return {
    name: data.node.name,
    role: data.node.acfUser.role,
    bio: data.node.description,
    image: data.node.acfUser.profileImage
      ? getImageBySize(data.node.acfUser.profileImage, 'square-small')
      : null,
  }
}
